import React from 'react';

const AllUsersAdmin = () => {
    return (
        <div>
            this is all users
        </div>
    );
};

export default AllUsersAdmin;